import { Container, Stack, StackItem, Typography } from '@optimus-web/core';
import { GuideLinkButton, QueryBoundary } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { ArticlePath, createGuideLink } from '@mews-commander/enums';
import { TaxWithholdingForm } from './form/TaxWithholdingForm';

export const TaxWithholdingSettingsPage = () => (
    <Container align="center" maxWidth="640px">
        <Stack vertical spacing="300">
            <Stack alignment="center" distribution="space-between">
                <StackItem>
                    <Typography textStyle="titleLargeStrong" as="h1">
                        {lt('TaxWithholdingTabTitle')}
                    </Typography>
                </StackItem>
                <StackItem>
                    <GuideLinkButton size="small" guideLink={createGuideLink(ArticlePath.BookingComTaxWithholding)} />
                </StackItem>
            </Stack>
            <StackItem>
                <Typography textStyle="bodyMedium" variant="tertiary" as="p">
                    {lt('TaxWithholdingPageDescription')}
                </Typography>
            </StackItem>
            <StackItem>
                <QueryBoundary>
                    <TaxWithholdingForm />
                </QueryBoundary>
            </StackItem>
        </Stack>
    </Container>
);
